import type { IconSvgObject } from './types';

const TwitterIcon: IconSvgObject = [
  ["path", { d: "M12.1136 8.98857C8.12894 9.319 4.51713 6.1532 3.41983 4.15272C3.41548 4.14479 3.40397 4.1468 3.40165 4.15554C2.1972 8.69844 3.50754 13.7342 6.456 16.3715C6.25963 16.6013 4.73045 18.4858 2.01021 18.5029C2 18.503 1.99606 18.5165 2.0049 18.5216C9.50578 22.8497 20.0062 17.1345 20.0062 8.38873L21.9911 4.51541C21.9948 4.50815 21.9887 4.49973 21.9806 4.50097L18.6432 5.01512C14.5364 2.0256 11.5441 6.33401 12.1136 8.98857Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default TwitterIcon;
